import { defineStore } from 'pinia';

const STORAGE_KEY = 'gradesRatingAvg';

function getDefaultData() {
  return {
    quarter: null,
    subject: '',
    type: null,
    classNumber: null,
    grade: null,
    formula: ''
  };
}

export const useAvgStore = defineStore('avg', {
  state: () => ({
    data: getDefaultData()
  }),
  actions: {
    setData(payload = {}) {
      this.data = {
        quarter: payload?.quarter ?? null,
        subject: payload?.subject ?? '',
        type: payload?.type ?? null,
        classNumber: payload?.classNumber ?? null,
        grade: payload?.grade ?? null,
        formula: payload?.formula ?? ''
      };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(this.data));
    },
    initFromStorage() {
      try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return;
        const parsed = JSON.parse(raw);
        if (parsed && typeof parsed === 'object') {
          this.data = { ...getDefaultData(), ...parsed };
        }
      } catch (error) {
        this.data = getDefaultData();
      }
    },
    clear() {
      this.data = getDefaultData();
      localStorage.removeItem(STORAGE_KEY);
    }
  }
});
